import { render, staticRenderFns } from "./VSidebarContainer.vue?vue&type=template&id=00a2add9&"
import script from "./VSidebarContainer.vue?vue&type=script&lang=js&"
export * from "./VSidebarContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports